import { useState } from "react";

interface TextAreaProps {
  name: string;
  labelText?: string;
  className?: string;
  labelClassName?: string;
  inputClassName?: string;
  placeholder?: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
  value: string;
  error?: string;
  isRequired?: boolean;
  maxLength?: number;
}

const TextArea = ({
  name,
  labelText,
  className,
  labelClassName,
  inputClassName,
  placeholder,
  onChange,
  onBlur,
  error,
  isRequired,
  value,
  maxLength,
}: TextAreaProps) => {
  const [isFocused, setIsFocused] = useState(false);
  return (
    <div className={`relative flex flex-col gap-[6px] w-full ${className}`}>
      {labelText && (
        <label
          htmlFor={name}
          className={`font-SatoshiMedium text-sm text-blueShades-4 ${labelClassName}`}
        >
          {labelText} {isRequired && <span className='text-ERROR'>*</span>}
        </label>
      )}
      <div
        className={`flex flex-col justify-between  rounded-md min-h-[100px] border ${isFocused ? "border-[1.5px] border-blueShades-6 outline outline-[3px] outline-[#D8E9F080]" : error ? "border-[1.5px] border-ERROR outline outline-3px outline-[#FFE5E5]" : "border-blueShades-2"} ${inputClassName}`}
      >
        <textarea
          onFocus={() => setIsFocused(true)}
          onBlur={(e) => {
            setIsFocused(false);
            onBlur && onBlur(e);
          }}
          name={name}
          id={name}
          onChange={onChange}
          value={value}
          placeholder={placeholder}
          maxLength={maxLength}
          className='resize-none min-h-[100px] w-full px-4 py-2 focus:outline-none placeholder:text-ashShade-16'
        ></textarea>
        {maxLength && (
          <span className='self-end text-xs pr-4 text-bash pb-2'>
            {value.length}/{maxLength}
          </span>
        )}
      </div>

      {error && (
        <span className='absolute left-0 top-full text-ERROR text-[13px] mb-4'>
          {error}
        </span>
      )}
    </div>
  );
};
export default TextArea;
